import React from 'react';
import { Phone, Mail, MapPin, Building2 } from 'lucide-react';
import logoImage from '@/assets/logo-black.png';

const Footer = () => {
  return (
    <footer className="bg-primary text-primary-foreground">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 lg:gap-16">
          {/* Company Info */}
          <div className="flex flex-col">
            <img 
              src={logoImage} 
              alt="Stichting Croostenburght" 
              className="h-28 md:h-32 w-auto object-contain brightness-0 invert self-start"
              width="128"
              height="128"
            />
            <p className="text-sm leading-relaxed text-primary-foreground/80 max-w-sm mt-8">
              Professioneel beheer en verhuur van hoogwaardige onroerend goed. 
              Persoonlijke service en betrouwbare communicatie staan centraal.
            </p>
          </div>

          {/* Navigation */}
          <div className="md:pt-1">
            <p className="text-sm font-semibold uppercase tracking-wider mb-5">Navigatie</p>
            <ul className="space-y-3">
              <li>
                <a href="/" className="text-sm text-primary-foreground/80 hover:text-primary-foreground transition-colors duration-200">
                  Home
                </a>
              </li>
              <li>
                <a href="/verhuur" className="text-sm text-primary-foreground/80 hover:text-primary-foreground transition-colors duration-200">
                  Verhuur
                </a>
              </li>
              <li>
                <a href="/projecten" className="text-sm text-primary-foreground/80 hover:text-primary-foreground transition-colors duration-200">
                  Projecten
                </a>
              </li>
              <li>
                <a href="/over-ons" className="text-sm text-primary-foreground/80 hover:text-primary-foreground transition-colors duration-200">
                  Over Ons
                </a>
              </li>
              <li>
                <a href="/contact" className="text-sm text-primary-foreground/80 hover:text-primary-foreground transition-colors duration-200">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="md:pt-1">
            <p className="text-sm font-semibold uppercase tracking-wider mb-5">Contact</p>
            <ul className="space-y-3">
              <li>
                <a href="https://maps.google.com/?q=Ticheldreef+104+Druten" target="_blank" rel="noopener noreferrer" className="flex items-start gap-3 text-sm text-primary-foreground/80 hover:text-primary-foreground transition-colors duration-200">
                  <MapPin className="h-4 w-4 mt-0.5 shrink-0" />
                  <span>Ticheldreef 104, 6651SH Druten</span>
                </a>
              </li>
              <li>
                <a href="tel:+31646006890" className="flex items-center gap-3 text-sm text-primary-foreground/80 hover:text-primary-foreground transition-colors duration-200">
                  <Phone className="h-4 w-4 shrink-0" />
                  <span>+31 6 46 00 68 90</span>
                </a>
              </li>
              <li>
                <a href="mailto:info@croostenburght.nl" className="flex items-center gap-3 text-sm text-primary-foreground/80 hover:text-primary-foreground transition-colors duration-200">
                  <Mail className="h-4 w-4 shrink-0" />
                  <span>info@croostenburght.nl</span>
                </a>
              </li>
              <li>
                <div className="flex items-center gap-3 text-sm text-primary-foreground/80">
                  <Building2 className="h-4 w-4 shrink-0" />
                  <span>KVK: 85013765</span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-primary-foreground/20 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-primary-foreground/70">
            &copy; {new Date().getFullYear()} Stichting Croostenburght. Alle rechten voorbehouden.
          </p>
          <div className="flex gap-6">
            <a href="#privacy" className="text-sm text-primary-foreground/70 hover:text-primary-foreground transition-colors duration-200">
              Privacy
            </a>
            <a href="#algemene-voorwaarden" className="text-sm text-primary-foreground/70 hover:text-primary-foreground transition-colors duration-200">
              Algemene Voorwaarden
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
